import { SavedUserData } from './types'

export const getFromLocalStorage = (key: string): SavedUserData => {
  if (typeof window !== 'undefined') {
    return JSON.parse(localStorage.getItem(key) || '{}')
  }

  return {}
}

export const saveToLocalStorage = (key: string, data: SavedUserData) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(data))
  }
}
